import { ApiLeadScoreAdjustmentRule, ApiProject } from "@incendium/api";
import { leadScoreAdjustmentService } from "Apis";
import { useProjectSharedState } from "./useSharedState";

const fetch = async (project: ApiProject) => {
  const rules =
    await leadScoreAdjustmentService.leadScoreAdjustmentRuleServiceListRules({
      projectId: project.id as number,
    });
  return rules.results || [];
};

export const useLeadScoreAdjustmentRules = () => {
  const { state, setState } = useProjectSharedState(
    "leadScoreAdjustmentRules",
    [],
    fetch
  );

  return {
    leadScoreAdjustmentRules: state as ApiLeadScoreAdjustmentRule[],
    setLeadScoreAdjustmentRules: setState,
  };
};
